module.exports = __webpack_public_path__ + "img/vulcans-tf-1.e3d1b90.jpg";